/* ==========================================================================
   Canadian Provinces & Territories List
   Shared list of province options for Select/dropdown components, used when
   an address (or the pharmacy) is Canadian (PORTAL-161). Mirrors usStates.ts.
   ========================================================================== */

import type { SelectOption } from '@/components/ui/Select'

export const CA_PROVINCES: SelectOption[] = [
  { value: 'AB', label: 'Alberta' },
  { value: 'BC', label: 'British Columbia' },
  { value: 'MB', label: 'Manitoba' },
  { value: 'NB', label: 'New Brunswick' },
  { value: 'NL', label: 'Newfoundland and Labrador' },
  { value: 'NS', label: 'Nova Scotia' },
  { value: 'NT', label: 'Northwest Territories' },
  { value: 'NU', label: 'Nunavut' },
  { value: 'ON', label: 'Ontario' },
  { value: 'PE', label: 'Prince Edward Island' },
  { value: 'QC', label: 'Quebec' },
  { value: 'SK', label: 'Saskatchewan' },
  { value: 'YT', label: 'Yukon' },
]
